import * as React from "react"

import {
  commonPermissionsList,
  useCommonPermissionsList,
} from "@boundless/bl-api-client/common/services"
import { useStore } from "zustand"

import { GenericErrorComponent } from "@/components/error/GenericErrorComponent"
import { PendingComponent } from "@/components/error/PendingComponent"
import { type Permission } from "@/lib/account/permission"
import { store } from "@/lib/store"

function Wrapper({ children }: { children: React.ReactNode }) {
  const { isPending, error } = useCommonPermissionsList({
    query: {
      queryFn: ({ signal }) => {
        return commonPermissionsList({ signal }).then((permissions) => {
          store.setState({ permissions: permissions as Permission[] })
          return permissions as Permission[]
        })
      },
    },
  })

  if (error) {
    return GenericErrorComponent({ error })
  }

  return <>{isPending ? <PendingComponent /> : children}</>
}

/**
 * @summary Initialize the Permission system for the whole application.
 */
export function PermissionWrapper({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useStore(store, (state) => state.isAuthenticated)

  if (!isAuthenticated) {
    return children
  }

  return <Wrapper>{children}</Wrapper>
}
